// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1pkbx","checkboxCol":"Table_checkboxCol__1yf0M","emailCol":"Table_emailCol__3sn9k","actionCol":"Table_actionCol__1roeN"};